import {client} from '@core/GraphQLProvider';
import {
    GetBrandReviewSummary,
    GetReviewPagination,
    DeleteReview,
    UpdateReviewVotes,
    UpdateReviewStatus,
    UpdateReviewResponse
} from './query.graphql';

if ( process.env.MOCK_API == 1 ) {
    require( './mocks' );
}

const BrandReviewService = {

    // Queries
    async getBrandReviewSummary ( input ) {
        const resp = await client.query( {
            query: GetBrandReviewSummary,
            variables: {...input}
        } );

        return resp.data.brandReviewSummary;
    },

    async getCustomerReviews ( input ) {
        const resp = await client.query( {
            query: GetReviewPagination,
            variables: {...input}
        } );

        return resp.data.reviewPagination;
    },

    // Mutations
    async voteUpReview ( {input, update} ) {
        return client.mutate( {
            mutation: UpdateReviewVotes,
            variables: {input},
            update: update || (( cache, resp ) => {
                console.log( resp );
                console.log( 'TODO - Update cache for onVoteUpReview mutation' );
            })
        } );
    },

    async deleteReview ( {input, update} ) {
        return client.mutate( {
            mutation: DeleteReview,
            variables: {input},
            update: update || (( cache, resp ) => {
                console.log( resp );
                console.log( 'TODO - Update cache for onDeleteReview mutation' );
            })
        } );
    },

    async respondToReview ( {input, update} ) {
        return client.mutate( {
            mutation: UpdateReviewResponse,
            variables: {input},
            update: update || (( cache, resp ) => {
                console.log( resp );
                console.log( 'TODO - Update cache for onRespondReview mutation' );
            })
        } );
    },

    async updateReviewStatus ( {input, update} ) {
        return client.mutate( {
            mutation: UpdateReviewStatus,
            variables: {input},
            update: update || (( cache, resp ) => {
                console.log( resp );
                console.log( 'TODO - Update cache for updateReviewStatus mutation' );
            })
        } );
    },

    // update strategies
    paginationUpdateStrategy: ( {brandId, requestCount, lastRequestIndex, ...filters} ) => ({
        query: GetReviewPagination,
        variables: {
            brandId,
            requestCount,
            lastRequestIndex,
            ...filters
        },
        updateQuery: ( prev, {fetchMoreResult} ) => {
            if ( !fetchMoreResult ) {
                return prev;
            }

            const prevPagination = prev.brandReviewSummary.reviewPagination;
            const {reviewPagination} = fetchMoreResult;

            // appends new reviews to existing list
            return {
                brandReviewSummary: {
                    ...prev.brandReviewSummary,
                    reviewPagination: {
                        ...reviewPagination,
                        lastRequestIndex,
                        reviews: [
                            ...prevPagination.reviews,
                            ...reviewPagination.reviews
                        ]
                    }
                }
            };
        }
    }),

    filterUpdateStrategy: ( {brandId, requestCount, lastRequestIndex, ...filters} ) => ({
        query: GetReviewPagination,
        variables: {
            brandId,
            requestCount,
            lastRequestIndex,
            ...filters
        },
        updateQuery: ( prev, {fetchMoreResult} ) => {
            if ( !fetchMoreResult ) {
                return prev;
            }

            const prevPagination = prev.brandReviewSummary.reviewPagination;
            const {reviewPagination: {reviews, totalRows}} = fetchMoreResult;

            // replace current list with a new list with filters applied
            return {
                brandReviewSummary: {
                    ...prev.brandReviewSummary,
                    reviewPagination: {
                        ...prevPagination,
                        lastRequestIndex: 0,
                        reviews,
                        totalRows
                    }
                }
            };
        }
    })
};

export default BrandReviewService;
